import React, { useState } from 'react';
import Swal from 'sweetalert2'

import * as Auth from "../../../Login/Auth"
import { ReqCheckSystemAccount, ReqAccountAdminAdd, ReqClientAdminAdd } from '../../../../item/ItemAccount';
import { api_checkSystemAccount } from '../../../../api/apiAccount';
import { SingleInput } from '../../Res/BaseInput';
import { CancelSubmitButton } from '../../Res/BaseButton';
import { ContentBox } from '../../Content/ContentBox';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { api_addClientAdmin } from '../../../../api/apiAdmin';


export function ClientAdminAdd() {
  const [account, setAccount] = useState("")
  const [nickName, setNickName] = useState("")
  const [email, setEmail] = useState("")
  const [isDisable, setIsDisable] = useState(false)

  function toCancel() {
    window.history.back();
  }
  
  function toCheck() {
    if (account !== "" && nickName !== "") {
      var mReqCheckSystemAccount = new ReqCheckSystemAccount({ mobile: account })
      api_checkSystemAccount({
        mReqCheckSystemAccount,
        success: (jsonData) => {
          if(jsonData.status){
            toAdd()
          }
        },
        failure: (err) => {
          Swal.fire({
            type: 'error',
            title: '提醒',
            text: err,
          })
        }
      })
    } else {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: '帳號, 密碼, 暱稱 不得為空',
      })
    }
  }

  function toAdd() {
    if (account !== "" && nickName !== "") {
      var userInfo = Auth.getUserInfo()
      var mReqClientAdminAdd = new ReqClientAdminAdd({
        mobile: account,
        nickName,
        email,
        isDisable,
        creatAccountId: userInfo.accountId
      })
      api_addClientAdmin({
        mReqClientAdminAdd,
        success: (jsonData) => {
          Swal.fire({
            type: 'success',
            title: '提醒',
            text: '新增成功',
          }).then(function () {
            setAccount("")
            setNickName("")
            setEmail("")
            setIsDisable(false)
            //window.history.replace("/ManagerList");
          })
        },
        failure: (err) => {
          Swal.fire({
            type: 'error',
            title: '提醒',
            text: err.message,
          })
        }
      })
    } else {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: '帳號, 暱稱 不得為空',
      })
    }
  }

  const isDisableItems = [
    { "val": 0, "name": "是" },
    { "val": 1, "name": "否" },
  ]

  var title = "申請人資訊"
  var content =
    <>
    {/*
      <div class="row">
        <div class="col-md-12">
          <SingleRedio title={"是否啟用"}
            arr={isDisableItems}
            val={isDisable ? 1 : 0}
            action={setIsDisable}
            size={4}
          />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
     */}

      <div className="row">
        <div className="col-md-12">
          <SingleInput title={"手機號碼-登入帳號"} val={account} action={setAccount} placeholder={"0988123456"} size={4} />
          <SingleInput title={"暱稱"} val={nickName} action={setNickName} placeholder={"鴨子"} size={4} />
          <SingleInput title={"電郵"} val={email} action={setEmail} placeholder={"XXX@XXX.com"} size={4} />
        </div>
      </div>
    </>

  var footer =
    <div class="row">
      <div class="col-sm-3 col-sm-offset-9">
        <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={toCheck} isRight={true} />
      </div>
    </div>

  return (
    <>
      <ContentBox title={title} content={content} footer={footer} hasDrawer={true} />
      <SystemPromptInput />
    </>
  )
}